/* ============================================================
   MC AMBASSADOR — single-feature slider with prev/next arrows
   ============================================================
   Slides sit side-by-side in a flex track (each 100% wide); prev/next
   translate the track. Wraps around. Off-screen slides are set inert so
   their links aren't in the tab order (keyboard) and aria-hidden for AT.
   Respects prefers-reduced-motion (no slide transition). Vanilla JS.
   ============================================================ */
(function () {
  'use strict';

  function initOne(root) {
    if (root.dataset.mcAmbReady) return;
    root.dataset.mcAmbReady = 'true';

    var track = root.querySelector('[data-mc-amb-track]');
    if (!track) return;
    var viewport = track.parentElement;
    var slides = Array.prototype.slice.call(track.children);
    var prev = root.querySelector('[data-mc-amb-prev]');
    var next = root.querySelector('[data-mc-amb-next]');
    if (slides.length < 2) return; // nothing to slide

    var index = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) track.style.transition = 'none';

    // Slides in a flex track otherwise all stretch to the tallest one, leaving a
    // big empty gap under shorter slides (very visible on mobile where bios vary
    // in length). Size the viewport to the ACTIVE slide instead.
    function setHeight() {
      if (!viewport || !slides[index]) return;
      var h = slides[index].offsetHeight;
      if (h) viewport.style.height = h + 'px';
    }

    // When the layout stacks (<=1024px: image above the bio), the top:50% arrows
    // land on the image/text. Move them below the image, level with the name
    // heading; on the desktop 2-column layout clear the inline top so the CSS
    // (top:50%) takes over.
    function positionArrows() {
      if (!prev && !next) return;
      if (window.innerWidth > 1024) {
        if (prev) prev.style.top = '';
        if (next) next.style.top = '';
        return;
      }
      var slide = slides[index];
      var anchor = slide.querySelector('.mc-ambassador__name') || slide.querySelector('.mc-ambassador__media');
      if (!anchor) return;
      var t = (anchor.getBoundingClientRect().top - root.getBoundingClientRect().top + anchor.offsetHeight / 2) + 'px';
      if (prev) prev.style.top = t;
      if (next) next.style.top = t;
    }

    function refresh() {
      setHeight();
      positionArrows();
    }

    function apply() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      for (var i = 0; i < slides.length; i++) {
        var active = i === index;
        slides[i].setAttribute('aria-hidden', active ? 'false' : 'true');
        // Keep off-screen slides out of the tab order + AT tree.
        if (active) slides[i].removeAttribute('inert');
        else slides[i].setAttribute('inert', '');
      }
      refresh();
      // Lazy images change the slide height once they load — recompute then.
      slides[index].querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', refresh, { once: true });
      });
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      apply();
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(refresh, 150);
    });
    window.addEventListener('load', refresh);

    apply();
  }

  function start() {
    var roots = document.querySelectorAll('[data-mc-ambassador]');
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
